import getUserMarkers from './getUserMarkers';


const settings = {
  getUserMarkers
};


export default settings;
